import { Toast as ToastDesktop } from "@/components/toast/components/toast";

export const Toast = ToastDesktop;
